import React from 'react'

const center = () => {
  return (
    <div>center</div>
  )
}

export default center